import { EventOperatorStableView } from './EventOperatorStableView'

export function EventOperatorApp({eventId}:{eventId:string}){
 return <EventOperatorStableView eventId={eventId}/>
}
